// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var draggable = require('share/components/hoc/Izenda.Draggable');

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var TreeView = require('share/components/controls/Izenda.TreeView');
  var DataCategoryItem = require('./Izenda.DataCategoryItem');
  var DataObjectItem = require('./Izenda.DataObjectItem');
  var DataFieldItem = require('./Izenda.DataFieldItem');
  var Actions = require('./Izenda.DataSourceTreeActions');

  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');

  var FieldPropertiesSchema = require('./Izenda.FieldPropertiesSchema');
  var CalculatedFieldPropertiesSchema = require('./Izenda.CalculatedFieldPropertiesSchema');

  var CALCULATED_FIELD_CATE_NAME = 'Calculated Fields';

  const { invoke, get, isNil, isEmpty, map, noop, filter } = require('lodash/fp');

  /**
   * DataTree component
   * Example :
   * <DataTree store={this.props.store} />
   */
  var DataTree = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      expandFieldLevel: React.PropTypes.bool,
      useCheckBox: React.PropTypes.bool
    },
    getDefaultProps: function() {
      return {
        expandFieldLevel: false,
        useCheckBox: true
      };
    },
    shouldComponentUpdate: function() {
      return false;
    },
    render: function() {
      var props = this.props;
      var classes = classnames('reports-dtsourcetree', props.className);

      var nodes = this.buildTree();
      var getChildNodes = invoke('getChildNodes');

      return (
        <div className={classes}>
          <TreeView
            className='u_paddingRight'
            nodes={nodes}
            renderNode={this.renderNode}
            getKey={this.getKey}
            getChildNodes={getChildNodes}
            nodeExpand={this.shouldExpand}
          />
        </div>
      );
    },

    renderNode: function(node, toggleIcon, toggle, isCollapsed) {

      switch (node.nodeType) {
        case 'Category': {
          return this.renderCategory(node.source, toggleIcon, toggle, isCollapsed);
        }
        case 'QuerySource': {
          return this.renderQuerySource(node.source, toggleIcon, toggle, isCollapsed);
        }
        case 'Field': {
          return this.renderField(node.source, node.querySource, toggleIcon, toggle, isCollapsed);
        }
        default: {
          return null;
        }
      }
    },

    renderCategory: function(node, toggleIcon, toggle, isCollapsed) {
      return <DataCategoryItem dataSource={node} collapseToggle={toggle} isCollapsed={isCollapsed} />;
    },

    renderQuerySource: function(node, toggleIcon, toggle, isCollapsed) {
      var store = this.props.store;
      var toggleSourceSelection = this.props.toggleSourceSelection;
      var filterText = store.dataTree.filterText;
      var useCheckBox = this.props.useCheckBox;

      return (
        <DataObjectItem
          dataSource={node}
          filterText={filterText}
          store={store}
          useCheckBox={useCheckBox}
          handleCheck={toggleSourceSelection}
          toggleIcon={toggleIcon}
          collapseToggle={toggle}
          isCollapsed={isCollapsed}
        />
      );
    },

    renderField: function(node, querySource, toggleIcon, toggle, isCollapsed) {
      var props = this.props;
      var store = props.store;
      var isCalculatedField = querySource.name === CALCULATED_FIELD_CATE_NAME && node.isCalculated;

      var buildFieldItem = function() {
        return (
          <DataFieldItem
            itemData={node}
            filterText={store.dataTree.filterText}
            store={store}
            isCalculated={isCalculatedField}
            clickDelete={props.deleteCalculatedField}
          />
        );
      };

      var buildDraggableFieldItem = function(uiStore) {
        var DraggableFieldItem = draggable(constants.GENNERAL.FIELD_ITEM, uiStore)(DataFieldItem);

        return (
          <DraggableFieldItem
            itemData={node}
            filterText={store.dataTree.filterText}
            dataObject={querySource}
            itemDataKey='id'
            propsEditors={getDefinedSchemaByFieldType(node)}
            isRerenderOnActive={true}
            checkRegistedItem={checkRegistedItem}
            store={store}
            isCalculated={isCalculatedField}
            clickDelete={props.deleteCalculatedField}
          />
        );
      };

      if (props.uiStore) {
        return buildDraggableFieldItem(props.uiStore);
      }
      return buildFieldItem();

      function checkRegistedItem(registedInfo) {
        return get('props.itemData', registedInfo) === node;
      }

      function getDefinedSchemaByFieldType(item) {
        var definedSchema;

        if (item.isCalculated && !isNil(item.reportId)) {
          definedSchema = CalculatedFieldPropertiesSchema;
        } else {
          definedSchema = FieldPropertiesSchema;
        }

        return [
          {
            name: 'dataSourceFieldProps',
            getDefinedSchema: definedSchema
          }
        ];
      }
    },

    buildTree: function() {
      var store = this.props.store;
      var uncategorized = store.dataTree.filterSource.length === 1 && !store.dataTree.filterSource[0].name;

      var extendCate = function(cate) {
        return {
          nodeType: 'Category',
          source: cate,
          getChildNodes: function() {
            if (cate.name === CALCULATED_FIELD_CATE_NAME) {
              isEmpty(cate.filterQuerySource) && (cate.filterQuerySource = []);
              return map(extendField(cate.filterQuerySource[0]), get('filterFields', cate.filterQuerySource[0]));
            }
            return map(extendQuerySource, cate.filterQuerySource);
          }
        };
      };

      var extendQuerySource = function(querySource) {
        return {
          nodeType: 'QuerySource',
          source: querySource,
          getChildNodes: function() {
            return map(
              extendField(querySource),
              filter({ inaccessible: false, visible: true }, querySource.filterFields)
            );
          }
        };
      };

      var extendField = function(querySource) {
        return function(field) {
          return {
            nodeType: 'Field',
            source: field,
            querySource: querySource,
            getChildNodes: noop
          };
        };
      };

      var tree = map(extendCate, store.dataTree.filterSource);
      return uncategorized ? tree[0].getChildNodes() : tree;
    },
    getKey: function(node) {
      // It must append name because there is possible of self-reference that has
      // same id but different name.
      var suffix = node.nodeType === 'Field' ? '_' + node.querySource.name : '';
      return node.source.id + '_' + node.source.name + suffix;
    },
    shouldExpand: function(node) {
      var expandFieldLevel = this.props.expandFieldLevel;
      var hasFilterText = this.props.store.dataTree.filterText.length > 0;
      return node.nodeType === 'Category' || hasFilterText || (expandFieldLevel && node.nodeType === 'QuerySource');
    }
  });

  module.exports = connect(Actions)(DataTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataSourceTree.jsx